import AclName from '../AclName.js';

export default [
  AclName.CrmSectionSystemBalancePrepaid,
  AclName.CrmPageSubscriptionPanel,
];
